import { useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { showToast, Typography } from 'shared/ui'
import { type CallNoteStore } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsNoteForm'
import { MessageField } from 'widgets/MessageField'
import styles from './styles.module.scss'

type ICallInsightCardsNoteFormProps = {
  store: CallNoteStore
}

export const CallInsightCardsNoteForm: FC<ICallInsightCardsNoteFormProps> = observer(
  ({ store }) => {
    const { messageFieldStore, prepareMessageData, handleMessageSend } = store

    useEffect(() => {
      if (messageFieldStore.textLimitReached) {
        showToast({
          type: 'error',
          title: messageFieldStore.textLimit.message,
        })
      }
    }, [messageFieldStore.messageInnerText.length])

    useEffect(() => {
      store.setMessageFieldData()

      return () => {
        prepareMessageData()
        handleMessageSend()
      }
    }, [])

    return (
      <div className={classNames(styles.wrap)}>
        <div className={styles.messageField}>
          <MessageField messageFieldStore={messageFieldStore} />
        </div>
        <Typography
          variant={'body-sm-regular'}
          color={'var(--content-primary-tertiary)'}
          tag='div'
          ariaLabel={'CallInsightCardsNoteDescription'}
        >
          This note will be saved when the call ends
        </Typography>
      </div>
    )
  }
)
